import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="places-api"
export default class extends Controller {
  static targets = ["searchInput", "urlInput"]
  connect() {
    if (google?.maps?.places) {
      this.initMap()
    } else {
      window.initMap = this.initMap.bind(this)
    }
  }

  initMap() {
    this.autocomplete = new google.maps.places.Autocomplete(this.searchInputTarget, {
      fields: ['url']
    })

    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace()
      if (place && place.url) {
        this.urlInputTarget.value = place.url
      } else {
        this.urlInputTarget.value = ''
      }
    })
  }
}
